import React,  {memo} from 'react';

// import Devanagari from './Devanagari';
import Transliteration from './Transliteration';
import Sandhi from './Sandhi';
import Identification from './Identification';

import Syntax from './Syntax';
import Translation from './Translation';
import Compounds from './Compounds';

// Last Question Verse components for "The Verse"
import LQV_Transliteration from './LQV_Transliteration';
import LQV_Sandhi from './LQV_Sandhi';
import LQV_Identification from './LQV_Identification';
import LQV_Syntax from './LQV_Syntax';
import LQV_Translation from './LQV_Translation';

// import RightSidebar from '../RightSidebar';
// import {UserContext} from '../../providers/UserProvider';

import '../css/Components.css';

const QnA =memo(({curQ, setQ, setCurQComplete, 
								setPartInst, curPi, curQComplete, 
								// states required to implement autosave on next and previous buttons
								btnClicked, setAnsSaved,
								// button to click sandhi part 
								partTwoBtn,
								// extra for compounds to be similar to OneQuestion
								p, a, type, n, s, email,
								// compounds
								compounds, setSidebar,
								// LQVerse's second set of states
								curQ2, setQ2, setCurQComplete2,
								// All verse questions for variable sentence count
								allVerseQuestions,
							}) =>{
	
	// const {currentUser} =useContext(UserContext); 
	console.log('QnA:', curQ.curPart, p, a, n, s);

	const partComponent = (curPart, takeInput) =>{
		let elementPart =curPart;
		if (type==='lElement')
			elementPart ='L-'+curPart
		
		console.log("# QnA #", elementPart, curQ.curPart, curQ2.curPart);

		switch(elementPart){
			case "transliteration":
				return <Transliteration curQ={curQ} setQ={setQ} setCurQComplete={setCurQComplete} 
					curPi={curPi} type={type} setPartInst={setPartInst} 
					setAnsSaved={setAnsSaved} btnClicked={btnClicked} partTwoBtn={partTwoBtn}/>;
			case "L-transliteration":
				return <LQV_Transliteration curQ={curQ} setQ={setQ} setCurQComplete={setCurQComplete} 
					curQ2={curQ2} setQ2={setQ2} setCurQComplete2={setCurQComplete2} 
					curPi={curPi} type={type} setPartInst={setPartInst} 
					setAnsSaved={setAnsSaved} btnClicked={btnClicked} partTwoBtn={partTwoBtn}
					allVerseQuestions={allVerseQuestions}/>;

			case "sandhi-analysis":
				return <Sandhi curQ={curQ} curPi={curPi} setCurQComplete={setCurQComplete} 
					type={type} setPartInst={setPartInst} setAnsSaved={setAnsSaved} btnClicked={btnClicked}/>;
			case "L-sandhi-analysis":
				return <LQV_Sandhi curQ={curQ} setQ={setQ} setCurQComplete={setCurQComplete} 
					curQ2={curQ2} setQ2={setQ2} setCurQComplete2={setCurQComplete2} 
					curPi={curPi} type={type} setPartInst={setPartInst} 
					setAnsSaved={setAnsSaved} btnClicked={btnClicked} partTwoBtn={partTwoBtn}
					allVerseQuestions={allVerseQuestions}/>;

			case "identification":
				return <Identification curQ={curQ} setQ={setQ} setCurQComplete={setCurQComplete} curPi={curPi} 
					type={type} setPartInst={setPartInst} setAnsSaved={setAnsSaved} btnClicked={btnClicked}/>;
			case "L-identification":
				return <LQV_Identification curQ={curQ} curQ2={curQ2} 
					setCurQComplete={setCurQComplete} setCurQ2Complete={setCurQComplete2} 
					curPi={curPi} setPartInst={setPartInst} setAnsSaved={setAnsSaved} btnClicked={btnClicked}
					allVerseQuestions={allVerseQuestions}/>
			
			case "syntax":
				return <Syntax curQ={curQ} curPi={curPi} setCurQComplete={setCurQComplete}
					type={type} setPartInst={setPartInst} setAnsSaved={setAnsSaved} btnClicked={btnClicked}/>;
			case "L-syntax":		
				return <LQV_Syntax curQ={curQ} curQ2={curQ2} curPi={curPi} 
					setPartInst={setPartInst} setAnsSaved={setAnsSaved} btnClicked={btnClicked}
					allVerseQuestions={allVerseQuestions}/>;
		
			case "translation":
				return <Translation curQ={curQ} curPi={curPi} setCurQComplete={setCurQComplete}
					type={type} setPartInst={setPartInst} setAnsSaved={setAnsSaved} btnClicked={btnClicked}/>;
			case "L-translation":
				console.log("Calling LQV_Translation")
				return <LQV_Translation curQ={curQ} curQ2={curQ2} curPi={curPi} setCurQComplete={setCurQComplete}
					type={type} setPartInst={setPartInst} setAnsSaved={setAnsSaved} btnClicked={btnClicked}
					allVerseQuestions={allVerseQuestions}/>;

			// Compound special case:
			case "compounds":
				return <Compounds parentQ={curQ} parentPi={curPi} setParentQComplete={setCurQComplete}
							setParentPartInst={setPartInst} setAnsSaved={setAnsSaved} btnClicked={btnClicked}
							p={p} a={a} type={type} n={n} s={s} email={email} compoundsInit={compounds} setSidebar={setSidebar}/>;
			case "L-compounds":
				return <Compounds parentQ={curQ}  parentQ2={curQ2} parentPi={curPi} setParentQComplete={setCurQComplete}
							setParentPartInst={setPartInst} setAnsSaved={setAnsSaved} btnClicked={btnClicked}
							p={p} a={a} type={type} n={n} s={s} email={email} compoundsInit={compounds} setSidebar={setSidebar}/>;

			default:
				if (takeInput)
					return "Work in progress ! Please come back later !";
				else
					return '';
		}
	}
	
	return (
		<div>
			<div className="QnA widthVW">
				{/* {console.log("@QnA", curQ.curPart, curQ.takeInput)} */}
				{partComponent(curQ.curPart, curQ.takeInput)}
			</div>
		</div>
	);
	
});

export default QnA;